/*
 * SH Custom: Brand Badge for Boost AI Search & Filter cards
 * Created: April 2026
 *
 * Boost renders product cards client-side from a template. Liquid can't
 * inject markup into Boost's grid, so we mirror the badge from snippets/
 * sh-brand-badge.liquid into each Boost card after Boost finishes its
 * render, and again on every re-render (filter change, page change).
 *
 * Label + per-brand colors come from Theme settings → Brand Badges, exposed
 * to this file via a JSON config block rendered by layout/theme.liquid into
 * <script type="application/json" id="sh-brand-badge-config">. Vendor →
 * brand-code match patterns stay hardcoded here because they map to actual
 * product.vendor strings in Shopify admin (renaming a vendor needs a code
 * update anyway, so surfacing those as settings would be misleading).
 *
 * Loaded only on collection templates via layout/theme.liquid scoping.
 */

(function () {
  'use strict';

  // Vendor → code matchers. Codes line up with the per-brand setting groups
  // in config/settings_schema.json (cmbt, drty, revsoc).
  var BRAND_MAP = [
    { match: /COMBAT IRON/i, code: 'cmbt' },
    { match: /DIRTY COWBOY/i, code: 'drty' },
    { match: /REVIVAL/i,      code: 'revsoc' }
  ];

  // Pull admin-editable label + colors from the Liquid-rendered JSON blob.
  // If the blob is missing (settings file out of sync, theme partially
  // deployed, etc.) fall back to the same defaults defined in the schema
  // so the badge still renders correctly.
  var CONFIG = { enabled: true, brands: {} };
  var configEl = document.getElementById('sh-brand-badge-config');
  if (configEl) {
    try {
      CONFIG = JSON.parse(configEl.textContent);
    } catch (e) { /* keep defaults */ }
  }
  var DEFAULTS = {
    cmbt:   { label: 'CMBT',   bg: '#000000', text: '#ffffff' },
    drty:   { label: 'DRTY',   bg: '#000000', text: '#ffffff' },
    revsoc: { label: 'REVSOC', bg: '#000000', text: '#ffffff' }
  };

  function brandFor(vendorText) {
    if (!vendorText) return null;
    for (var i = 0; i < BRAND_MAP.length; i++) {
      if (BRAND_MAP[i].match.test(vendorText)) return BRAND_MAP[i].code;
    }
    return null;
  }

  function settingsFor(code) {
    var s = (CONFIG.brands && CONFIG.brands[code]) || {};
    var d = DEFAULTS[code] || {};
    return {
      // SH Updated: October 2026 - an explicit empty label (blank in Theme settings) hides that brand's badge
      label: (typeof s.label === 'string') ? s.label : d.label,   // '' hides; null/undefined falls back to the default
      bg:    s.bg    || d.bg,
      text:  s.text  || d.text
    };
  }

  function inject(card) {
    if (!CONFIG.enabled) return;
    if (!card || card.querySelector(':scope > .sh-brand-badge')) return;
    var vendorEl = card.querySelector('.boost-sd__product-vendor');
    if (!vendorEl) return;
    var code = brandFor(vendorEl.textContent);
    if (!code) return;

    var cfg = settingsFor(code);
    if (!cfg.label) return;          // admin cleared label → render nothing

    var badge = document.createElement('div');
    badge.className = 'sh-brand-badge sh-brand-badge--' + code;
    badge.setAttribute('aria-hidden', 'true');
    badge.style.setProperty('--sh-bb-bg', cfg.bg);
    badge.style.setProperty('--sh-bb-color', cfg.text);
    badge.textContent = cfg.label;
    card.appendChild(badge);
  }

  function scan(root) {
    if (!CONFIG.enabled) return;
    var scope = root || document;
    var cards = scope.querySelectorAll('.boost-sd__product-item');
    for (var i = 0; i < cards.length; i++) inject(cards[i]);
  }

  // First pass on initial DOM ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Boost re-renders the grid on filter/sort/pagination changes — a
  // MutationObserver on the grid container catches those without us
  // hooking into Boost's internal events.
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('.boost-sd__product-item')) {
          inject(node);
        } else if (node.querySelectorAll) {
          scan(node);
        }
      }
    }
  });

  function startObserver() {
    var grid = document.querySelector('.boost-sd__product-list, .boost-sd__main-content');
    if (grid) {
      scan(grid);
      observer.observe(grid, { childList: true, subtree: true });
    } else {
      setTimeout(startObserver, 500);
    }
  }
  startObserver();

  // Failsafe: catch a first Boost render that beats both the initial
  // DOMContentLoaded pass AND observer attachment. The MutationObserver
  // handles every later re-render, so we only need to poll until the grid
  // first populates, then stop — bailing on the first populated scan instead
  // of blindly re-scanning the whole document for 15s (SH Updated July 2026:
  // was 30 iterations/15s; now bails on first cards, caps at 8/4s — trims
  // needless main-thread work on the collection page).
  var failsafeCount = 0;
  var failsafeTimer = setInterval(function () {
    scan();
    failsafeCount++;
    if (document.querySelector('.boost-sd__product-item') || failsafeCount >= 8) {
      clearInterval(failsafeTimer);
    }
  }, 500);
})();
